import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { CommonStyles } from '@/atoms/Menu/RadixMenu/common';
import { IconContainer } from '@/components/Atoms/IconContainer/IconContainer';
import ArrowRight from '@/icons/filled-chevron-right.svg?react';

export const SubMenuButton = React.forwardRef<
  HTMLDivElement,
  DropdownMenuPrimitive.DropdownMenuSubTriggerProps
>(({ children, ...props }, forwardedRef) => {
  return (
    <StyledTrigger asChild ref={forwardedRef} {...props}>
      <button>
        {children}
        <IconContainer className='h-5 w-5'>
          <ArrowRight />
        </IconContainer>
      </button>
    </StyledTrigger>
  );
});

const StyledTrigger = styled(DropdownMenuPrimitive.SubTrigger)`
  ${CommonStyles}

  ${tw`justify-between gap-x-2`}
`;
